import { SelectChangeEvent, MenuItem, Typography, Select } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { selectStyle } from '../../constants/styleConstants'
import { AppDispatch } from '../../store'
import questionsSelector from '../../store/questions/questionsSelector'
import {
  updateNewCaseAnswerOption,
  updateVictimAnswerOption,
} from '../../store/questions/questionsSlice'
import { IQuestionV2 } from '../../store/reports/types'

import { ReactComponent as ArrowIcon } from '../../assets/images/arrowIcon.svg'
import FormLayout from '../forms/FormLayout'
import DividerTAG from '../DividerTAG'
import { questionParser } from '.'
import colors from '../../constants/colors'

interface ILogicalQuestion {
  question: IQuestionV2
  isParent?: boolean
  victimQuestionId?: number | null
}

const LogicalQuestion: React.FC<ILogicalQuestion> = ({
  question,
  isParent = false,
  victimQuestionId = null,
}) => {
  const getAnswer = () => {
    if (victimQuestionId) {
      return useSelector(questionsSelector.getVictimAnswer(victimQuestionId, question?.uuid))
    }
    return useSelector(questionsSelector.answerToNewCaseQuestion(question?.uuid))
  }
  const answer = getAnswer()
  const dispatch = useDispatch<AppDispatch>()

  const optionsAndSubquestions = question?.options.map((option, index) => {
    const found = question?.subquestions.filter(subQuestion => subQuestion?.option === option.id)
    return found?.length > 0
      ? {
          option,
          subquestions: found,
        }
      : {
          option,
        }
  })
  const onChangeHandler = (event: SelectChangeEvent) => {
    if (victimQuestionId) {
      dispatch(
        updateVictimAnswerOption({
          victimId: victimQuestionId,
          answerUUID: answer?.uuid,
          answerText: [event.target.value as unknown as number],
        }),
      )
      return
    }
    dispatch(
      updateNewCaseAnswerOption({
        answerUUID: answer?.uuid,
        answerText: [event.target.value as unknown as number],
      }),
    )
  }

  const renderSelectOptions = () => {
    return question.options.map(({ id, text }, index) => {
      return (
        <MenuItem value={id} key={id}>
          <Typography variant='bodyBold'>{text}</Typography>
        </MenuItem>
      )
    })
  }
  return (
    <FormLayout>
      {!isParent && (
        <Typography variant='bodyBold' color={colors.TAG_BLUE}>
          {question?.text_third}
        </Typography>
      )}
      <Select
        onChange={onChangeHandler}
        value={(answer?.options[0] as unknown as string) ?? ''}
        IconComponent={ArrowIcon}
        displayEmpty
        sx={[selectStyle]}
      >
        {renderSelectOptions()}
      </Select>
      {question?.subquestions?.length > 0 && answer?.options?.find(element => element == 31) && (
        <FormLayout>
          <DividerTAG />
          {question?.subquestions.map(subquestion =>
            questionParser(subquestion, false, victimQuestionId),
          )}
        </FormLayout>
      )}
    </FormLayout>
  )
}

export default LogicalQuestion
